import { useState } from 'react'

import Chevron from 'assets/icons/Chevron.svg'
import { Question, QuestionSection } from 'constants/HomeConstants'

interface AccordionStackProps {
  color?: string
  questions: QuestionSection[]
}

export const AccordionStack = ({ questions }: AccordionStackProps) => {
  const [page, setPage] = useState(0)

  // Only ONE open at a time
  const [open, setOpen] = useState<number | null>(0)

  const changePage = (page: number) => {
    setPage(page)
    setOpen(0) // reset first question open on page change
  }

  const toggleOpen = (index: number) => {
    setOpen(prev => (prev === index ? null : index))
  }

  return (
    <div className="flex flex-col lg:flex-row lg:justify-center gap-4 lg:gap-0">
      {/* LEFT MENU */}
      <div className="flex flex-col w-full lg:w-[288px] lg:mr-12 aria-expanded:bg-[#6BCB83]">
        {questions.map((section, index) => (
          <button
            key={index}
            onClick={() => changePage(index)}
            aria-expanded={page === index}
            className="w-full lg:w-[284px] text-left mb-3 px-[14px] py-[10px] btn-homepage-accordion subtitle-s"
          >
            {section.section}
          </button>
        ))}
      </div>

      {/* RIGHT ACCORDION */}
      <div className="w-full lg:w-[784px] px-4 md:px-6 rounded-3xl bg-white border border-solid border-gray divide-y">
        {questions[page]?.questions.map((question: Question, index) => {
          const isActive = open === index

          return (
            <div
              key={index}
              onClick={() => toggleOpen(index)}
              aria-expanded={isActive}
              className={`border-b last:border-b-0 ${index + 1 !== questions.length && 'border-solid'} border-gray py-6 group cursor-pointer`}
            >
              {/* Title */}
              <p className="flex justify-start items-center gap-4 subtitle-xl">
                <img src={Chevron} alt="Chevron" className={`transition ease-in-out ${isActive ? 'rotate-180' : ''}`} />
                {question.title}
              </p>

              {/* Content */}
              <div
                className={`ml-4 md:ml-[48px] body-s overflow-hidden transition-all duration-300 ${
                  isActive ? 'max-h-96 opacity-100 translate-y-0 mt-3' : 'max-h-0 opacity-0 translate-y-3'
                }`}
              >
                {question.content}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
